"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PendingItemType;
(function (PendingItemType) {
    PendingItemType["OVERDUE"] = "overdue";
    PendingItemType["DRAFT"] = "draft";
    PendingItemType["PENDING_REACTION"] = "reaction";
    PendingItemType["PENDING_ACTION"] = "action";
})(PendingItemType = exports.PendingItemType || (exports.PendingItemType = {}));
//# sourceMappingURL=pending-item-type.js.map